import React from 'react';
import { Link, useNavigate } from "react-router-dom";
import config from 'src/config/config';
import styled, { css, withTheme } from 'styled-components';
import { theme } from 'styled-tools';
import Intl from '../common/Intl'
import { Tittle as FooterTittle } from '../udb/commonStyle';
import { withAppContext } from 'src/store/initAppContext';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import PlaceholderImage from 'src/components/Placeholder';
import FooterSeoLinks from './footer-seo-links';
import { useSocialMediaLinks } from 'src/hooks/useSocialMediaLinks';

function FooterContainer(props: any) {
    const { app: { brandId }, theme } = props
    const { config: { showFooterNetbanking, showPartners, showFooterastropay, showOnlyOnFomo, showAgProvider, showOnlyOnFun,ShowPrincipalAwardLogo, showFun88Sponcers, showSupernowaProvider, showOnlyOnCrypto } } = theme;

    const brandUrlConfig: Record<number, string> = {
        33: 'https://m.iw247.com',
        39: 'https://www.fomo7.net',
        40: 'https://www.fomo7.xyz',
        46: 'https://www.fun88.site',
        47: 'https://www.fun88.live',
    };
    const brandUrl = brandUrlConfig[brandId] || '';

    const {socialMediaLinks, loading, hasSocialLinks} = useSocialMediaLinks(brandId);
    const brandLogo = brandId === 33 || brandId === 34 ? theme.image.new_whitelable_logo_betdaily
        : showOnlyOnFomo ? theme.image.new_whitelable_logo_fomo
        : showOnlyOnFun ? theme.image.footerLogo : theme.image.footerLogo;
    
    const tetherLogo = showOnlyOnFun ? "tetherFooterLogoBlack.png" : "tetherFooterLogo.png";

    const domainUrl = brandId === 46 ? "support@fun88.site" : brandId === 47 ? "support@fun88.live" : "";

    const navigate = useNavigate();
    const openSponsors = () => {
          navigate('/sponsors');
    }

    return (
      <Container>
        <SponsorSection>
          {ShowPrincipalAwardLogo && (
            <>
              {showOnlyOnFomo ? (
                   <SponsersWapperK9 onClick={!showOnlyOnFomo && openSponsors}>
                        <a
                            href={`${brandUrl}/sponsorship/fomo7-becomes-title-sponsor-of-barbados-royals/`}
                        >
                            <LazyLoadImage
                                src={`${config.imageV3Host}/static/media/footerSponsorFomo01.png`}
                                effect="none"
                                width="80%"
                                placeholder={<PlaceholderImage />}
                                alt="Associate sponsor"
                            />
                      </a>
                      <CenterLine></CenterLine>
                      <a
                            href={`${brandUrl}/sponsorship/fomo7-games-forges-title-sponsor-with-purani-dilli-6-in-dpl-2024/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo02.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                      <CenterLine></CenterLine>
                      <a
                            href={`${brandUrl}/sponsorship/fomo7-forays-into-tnpl-with-trichy-grand-cholas-sponsorship/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo03.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                      <CenterLine></CenterLine>
                      <a
                            href={`${brandUrl}/sponsorship/fomo7-games-is-sri-lankas-overseas-back-of-shirt-sponsor/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo04.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                      <CenterLine></CenterLine>
                      <a
                            href={`${brandUrl}/sponsorship/world-championship-of-legends/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo05.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                      <CenterLine></CenterLine>
                      <a
                            href={`${brandUrl}/sponsorship/major-league-cricket/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo06.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                      <CenterLine></CenterLine>
                       <a
                            href={`${brandUrl}/sponsorship/fomo7-games-teams-up-with-lpl-as-associate-partner-for-2024-season/`}
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFomo07.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      </a>
                    </SponsersWapperK9>
              ) : (
                <>
                </>
              )}

              {showFun88Sponcers && (
                <SponsersWapperK9 onClick={openSponsors}>
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun01.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun02.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun03.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun04.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun05.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun06.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun07.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/footerSponsorFun08.png`}
                        effect="none"
                        width="80%"
                        placeholder={<PlaceholderImage />}
                        alt="Associate sponsor"
                      />
                    </SponsersWapperK9>
              )}
            </>
          )}
        </SponsorSection>

        <FooterSeoLinks />

        <GamingPartners>
          <Tittle>
            <Intl langKey="FOOTER@GAMINGPARTNERS" />
          </Tittle>
          <Link to="/live-casino/ezugi">
            {
              <LazyLoadImage
                src={`${config.imageV3Host}/static/media/${theme.image.ezugiLogoNov24}`}
                effect="none"
                placeholder={<PlaceholderImage />}
                visibleByDefault={false}
              />
            }
          </Link>
          {showAgProvider && (
            <Link to="/live-casino/ag">
              <LazyLoadImage
                src={`${config.imageV3Host}/static/media/aGLogoNew.png`}
                effect="none"
                placeholder={<PlaceholderImage />}
                visibleByDefault={false}
              />
            </Link>
          )}
          <Link to="/live-casino/betgames">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/betGamesLogoNew.png`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
          <Link to="/live-casino/evolution">
            {
              <LazyLoadImage
                src={`${config.imageV3Host}/static/media/${theme.image.evolutionGamesNov24}`}
                effect="none"
                placeholder={<PlaceholderImage />}
                visibleByDefault={false}
              />
            }
          </Link>
          <Link to="/slots/netent">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/netentLogoNew.png`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
          <Link to="/live-casino/tvbet">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/${theme.image.tvbetLogoNov24}`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
          {showSupernowaProvider && (
            <Link to="/live-casino/supernowa">
              <LazyLoadImage
                src={`${config.imageV3Host}/static/media/supernowaLogoNew.png`}
                effect="none"
                placeholder={<PlaceholderImage />}
                visibleByDefault={false}
              />
            </Link>
          )}
          <Link to="/sportsbook">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/BTILogoNew.png`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
          <Link to="/live-casino/7mojos">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/7mojosIcon.png`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
          <Link to="/instant-games/spribe">
            <LazyLoadImage
              src={`${config.imageV3Host}/static/media/${theme.image.spribeLogoFooterNov24}`}
              effect="none"
              placeholder={<PlaceholderImage />}
              visibleByDefault={false}
            />
          </Link>
        </GamingPartners>

        {hasSocialLinks && !loading && (
          <SocialSection>
            <div className="socialMediaWrapper">
              {socialMediaLinks.map((item: any, index: number) => {
                const { label, url, icon } = item;
                return (
                  <a
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    key={`${label}-${index}`}
                  >
                    <LazyLoadImage
                      src={`${config.imageV3Host}${icon}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                      alt={label}
                    />
                  </a>
                );
              })}
            </div>
          </SocialSection>
        )}

        <FooterInformation>
          <BrandInformation>
            <div className="logosWrap">
              <BrandLogo>
                <Link to="/">
                  <LazyLoadImage
                    src={`${config.imageV3Host}/static/cashsite/${brandLogo}`}
                    effect="none"
                    alt="Brand logo"
                    placeholder={<PlaceholderImage />}
                  />
                  </Link>
              </BrandLogo>
              <AppDownload>
                 <Link to="/app-download">
                    <LazyLoadImage
                    src={`${config.imageV3Host}/static/media/${theme.image.AppDwnldImg}`}
                    effect="none"
                    alt="Brand logo"
                    placeholder={<PlaceholderImage />}
                    />
                </Link>
              </AppDownload>
            </div>
            <BrandNoteLeft>
               <Intl langKey="FOOTER@BrandNoteLeft" />{" "}
            </BrandNoteLeft>
            <ResponsibleGamingLogos>
              <a
                href="https://www.gamstop.co.uk/"
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src={`${config.imageV3Host}/static/media/gamestopLogo.png`}
                  effect="none"
                  placeholder={<PlaceholderImage />}
                  visibleByDefault={false}
                />
              </a>
              <a
                href="https://www.begambleaware.org/"
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src={`${config.imageV3Host}/static/media/${theme.image.beAwareLogoNov24}`}
                  effect="none"
                  placeholder={<PlaceholderImage />}
                  visibleByDefault={false}
                />
              </a>
              <a
                href="https://www.gamcare.org.uk/"
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                  src={`${config.imageV3Host}/static/media/${theme.image.gamcareLogoNov24}`}
                  effect="none"
                  placeholder={<PlaceholderImage />}
                  visibleByDefault={false}
                />
              </a>
              <Span>
                <LazyLoadImage
                  src={`${config.imageV3Host}/static/media/${theme.image.eighteenPlusLogoNov24}`}
                  effect="none"
                  placeholder={<PlaceholderImage />}
                />
              </Span>
            </ResponsibleGamingLogos>

            {brandId && (brandId !== 33 && brandId !== 61) &&
            <PaymentMethods>
                  {showFooterNetbanking && (
                    <NonClick>
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/${theme.image.internetBankingNewNov24}`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                        visibleByDefault={false}
                      />
                    </NonClick>
                  )}
                  <NonClick>
                     <a
                href="https://paytm.com/"
                target="_blank"
                rel="noreferrer"
              >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/paytmLogoNew.png`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                   <NonClick>
                    <a
                href="https://pay.google.com/gp/w/u/0/home/signup"
                target="_blank"
                rel="noreferrer"
              >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/${theme.image.gpayLogoNewNov24}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                  <NonClick>
                     <a
                href="https://www.npci.org.in/product/upi/"
                target="_blank"
                rel="noreferrer"
              >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/${theme.image.upiLogoNewNov24}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                 <NonClick>
                    <a
                href="https://tether.to/en/"
                target="_blank"
                rel="noreferrer"
              >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/${tetherLogo}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
               </a>
                  </NonClick>
                  {showFooterastropay && (
                    <NonClick>
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/astropayLogoNew.png`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                        visibleByDefault={false}
                      />
                    </NonClick>
                  )}
            </PaymentMethods>}
          </BrandInformation>

          <Certificate>
            <CertificateImg>
               {showOnlyOnFun ? (
                <a
                href="https://anjouangaming.com/"
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                    src={`${config.imageV3Host}/static/media/anjouanGamingLogoFooter.png`}
                    effect="none"
                    alt="anjouan Gaming"
                    placeholder={<PlaceholderImage />}
                    visibleByDefault={false}
                    width="70%"
                />
              </a>)
              : (
               <a
                href={showOnlyOnFomo ? "https://go.fomo7-in.com/fomo7-certification" : "https://cert.cga.cw"}
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                    src={`${config.imageV3Host}/static/media/${theme.image.FooterGcbCertificateImg}`}
                    effect="none"
                    alt="gcb certificate"
                    placeholder={<PlaceholderImage />}
                    visibleByDefault={false}
                    width="100%"
                />
              </a>)}
              {!showOnlyOnFun && <a
                href="https://cert.cga.cw/"
                target="_blank"
                rel="noreferrer"
              >
                <LazyLoadImage
                src={`${config.imageV3Host}/static/media/${theme.image.FooterGcbCertificateImg2}`}
                effect="none"
                alt="gcb certificate"
                placeholder={<PlaceholderImage />}
                visibleByDefault={false}
                width="100%"
              />
              </a>}
            </CertificateImg>
            {(brandId !== 33 && brandId !== 61 ) && (
              <CertificateTitle>
                <CertificateText className='fun88contactus'>
                  <Intl langKey="FOOTER@CERTIFICATIONSTEXT" />{" "}
                  {showOnlyOnFun && <p><Intl langKey="FOOTER@CONTACTUS" />{" "} <a href={`mailto:${domainUrl}`}>{domainUrl}</a></p>}
                </CertificateText>{" "}
                <CertificateText>
                  <Intl langKey="FOOTER@CERTIFICATIONSTEXT2" />
                </CertificateText>
              </CertificateTitle>
            )}
            {showOnlyOnFun &&
            <>
               <LineSeperator></LineSeperator>
               <div className='logosWrap funTermsLink'>
                    <Link to="/about/terms-conditions"><Intl langKey="FooterSeoLinks@TERMSCONDITIONS" /></Link>
                    <Link to="/about/responsible-gambling"><Intl langKey="FooterSeoLinks@RESPONSIBLEGAMBLING" /></Link>
                    <Link to="/about/privacy-policy"><Intl langKey="FooterSeoLinks@PRIVACYPOLICY" /></Link>
                    <Link to="/about/kyc-policy"><Intl langKey="FooterSeoLinks@KYCPOLICY" /></Link>
               </div>
            </>
            }
            {(brandId && brandId === 33 || brandId === 61) &&  <PaymentMethods>
              {brandId === 61 ? (
                <>
                  {/* <NonClick>
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/footerUsdtLogo.png`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                  </NonClick> */}
                  <NonClick>
                      <a
                          href="https://tether.to/en/"
                          target="_blank"
                          rel="noreferrer"
                      >
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/tetherFooterLogo.png`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                        visibleByDefault={false}
                      />
                      </a>
                    </NonClick>
                  </>
              ) : (
                <>
                  {showFooterNetbanking && (
                    <NonClick>
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/${theme.image.internetBankingNewNov24}`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                        visibleByDefault={false}
                      />
                    </NonClick>
                  )}
                  <NonClick>
                    <a
                        href="https://paytm.com/"
                        target="_blank"
                        rel="noreferrer"
                    >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/paytmLogoNew.png`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                   <NonClick>
                    <a
                        href="https://pay.google.com/gp/w/u/0/home/signup"
                        target="_blank"
                        rel="noreferrer"
                    >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/${theme.image.gpayLogoNewNov24}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                  <NonClick>
                    <a
                        href="https://www.npci.org.in/product/upi/"
                        target="_blank"
                        rel="noreferrer"
                    >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/${theme.image.upiLogoNewNov24}`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                 <NonClick>
                    <a
                        href="https://tether.to/en/"
                        target="_blank"
                        rel="noreferrer"
                    >
                    <LazyLoadImage
                      src={`${config.imageV3Host}/static/media/tetherFooterLogo.png`}
                      effect="none"
                      placeholder={<PlaceholderImage />}
                      visibleByDefault={false}
                    />
                    </a>
                  </NonClick>
                  {showFooterastropay && (
                    <NonClick>
                      <LazyLoadImage
                        src={`${config.imageV3Host}/static/media/astropayLogoNew.png`}
                        effect="none"
                        placeholder={<PlaceholderImage />}
                        visibleByDefault={false}
                      />
                    </NonClick>
                  )}
                </>
              )}
            </PaymentMethods>
          }
          </Certificate>

        </FooterInformation>

        <CopyrightRow>
          <Intl langKey="FOOTER@COPYRIGHT" />
        </CopyrightRow>
      </Container>
    );
}

export default withTheme(withAppContext(FooterContainer));

//Styled Components

const CenterLine = styled.div`
    height: 65px;
    padding: 0 1px;
    background: ${theme('palette.footerSponsorsCenterLineBg')};
    align-self: center;
`;

const NonClick = styled.div`
    width: 8%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 5px;
    transition: all 0.2s ease-in-out 0s;
`;

const CertificateImg = styled(NonClick)`
    width: ${theme('palette.footerCertificatesImage')};
    display: flex;
    gap: 10px;

    a {
        width: 100% !important;
    }
`;

const Tittle = styled(FooterTittle)<{ $propsAdd?: boolean; }>`
    width: 100%;
    color: ${theme('palette.footerTittleColor')};
    text-transform: capitalize;
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;

    ${props => props.$propsAdd &&
    css`
        font-size: 14px;
    `};
`;

const Container: any = styled.div`
    width: 100%;
    background: ${theme('palette.footerbgColor')};
    position: relative;
`;

const CopyRight = styled.div`
    width: 100%;
    display: flex;
	align-items:center;
	justify-content: center;
    flex-wrap: wrap;
    color: ${theme('palette.footerDefaultColor')};
    font-size: 15px;
    text-align: center;
	line-height: 20px;
	padding-left: 10px;
    padding: 30px 0;
    padding-bottom: 10px;
    margin: 0 auto;

	a {
        width: 8%;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px 10px;
        border-radius: 5px;
		transition: all 0.2s ease-in-out 0s;
	}

	a:hover {
        background-color: ${theme('palette.footerLogoHoverBg')};
	}

    img {
        max-width: 100%;
        transition: all 0.2s ease-in-out 0s;
    }

    .socialMediaWrapper {
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            width: 40px;
            height: 35px;
            margin: 0px 5px;
            display: flex;
            padding: 0;

            img {
                width: 100%;
                border: ${theme('palette.footerSocialMediaBorder')};
                border-radius: 20px;
            }

            :hover {
                background-color: transparent;

                img {
                    border: ${theme('palette.footerSocialMediaBorderHover')};
                }
            }
        }
    }
`;

const SponsorSection = styled(CopyRight)`
    max-width: 1400px;
`;

const GamingPartners = styled(CopyRight)`
    max-width: 1400px;
    padding: 2rem 0;
    background: ${theme('palette.usefulLinksBg')};
    border-top: 1px solid rgba(127, 127, 127, 0.2);
`;

const SocialSection = styled(CopyRight)`
    max-width: 1400px;
    padding: 2rem 0;
    border-bottom: 1px solid rgba(127, 127, 127, 0.2);
`;

const FooterInformation = styled.div`
    width: 100%;
    max-width: 1400px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 3rem;
    margin: 0 auto;
    padding: 2rem;
    color: ${theme('palette.footerDefaultColor')};
    border-bottom: 1px solid rgba(127, 127, 127, 0.2);

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 2rem;
        padding: 1.5rem 1rem;
    }

    .logosWrap {
        display: flex;
        gap: 25px;
    }

    .funTermsLink {
        a {
            color: #000;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 171.2%;
            text-transform: capitalize;
            position: relative;

            &::after {
                content: "|";
                position: absolute;
                right: -15px;
            }

            &:last-child::after {
                content: "";
                display: none;
            }
        }
    }
`;

const BrandInformation = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 1.5rem;
`;

const BrandLogo = styled.div`
    display: flex;
    align-items: center;
    min-height: 60px;

    img {
        width: auto;
        max-width: 300px;
        max-height: 50px;
        object-fit: contain;
    }
`;

const AppDownload = styled.div`
    display: flex;
    align-items: center;
    min-height: 60px;

    img {
        width: auto;
        max-width: 150px;
        max-height: 50px;
        object-fit: contain;
    }
`

const ResponsibleGamingLogos = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.25rem;

    a,
    > div {
        width: auto;
        display: flex;
        align-items: center;
        padding: 0;
    }

    img {
        width: auto;
        max-width: 110px;
        max-height: 34px;
        object-fit: contain;
    }
`;

const PaymentMethods = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 1.5rem;

    > div {
        width: auto;
        min-width: 64px;
        padding: 0;
    }

    img {
        width: auto;
        max-width: 115px;
        max-height: 40px;
        object-fit: contain;
    }
`;

const Certificate = styled.div`
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    color: ${theme('palette.footerDefaultColor')};
    gap: 20px;

    ${Tittle} {
        text-align: left;
    }
`;

const CopyrightRow = styled.div`
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 1.5rem 1rem;
    color: ${theme('palette.footerDefaultColor')};
    text-align: center;
    font-size: 13px;
`;

const Span = styled.div`
  padding-right:10px;
  font-size:13px;
  text-transform: capitalize;

  img {
    width: 34px;
    height: 34px;
    margin: 0px 10px;
  }
`;

const CertificateTitle = styled(Tittle)`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    flex-direction: column;

    & .fun88contactus {
      display: inline-block;

      & p {
        margin: 3px 0px;
        a {
          text-transform: lowercase;

          :hover {
            text-decoration: underline;
          }
        }

        
      }
    }
`;

const CertificateText = styled.p`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    text-align: left;
`;

const SponsersWapperK9 = styled.div`
    width: 100%;
    max-width: 1400px;
    display: flex;
    gap: 5px;
    justify-content: center;
    cursor: pointer;

    & img {
        width: 144px;
        height: 77px;
        object-fit: contain;
    }

    & a {
        width: 144px;
        height: 77px;
        object-fit: contain;
    }
`

const BrandNoteLeft = styled.p`
    width: 100%;
    text-align: left;

`

const LineSeperator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(127, 127, 127, 0.2);
`
